import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'

import { ColumnPickerAvailableNodes } from './ColumnPickerAvailableNodes'
import { ColumnPickerCategoryList } from './ColumnPickerCategoryList'
import { ColumnPickerPagination } from './ColumnPickerPagination'
import messages from './messages'
import * as S from './styles'
import { useAvailableColumnsQuery } from './useAvailableColumnsQuery'
import { useCategorySelection } from './useCategorySelection'
import type { ColumnCategory } from './useColumns'
import { getExitIcon, getExitOnClick } from './utils'

interface ColumnPickerCategoriesProps {
  columnCategories: ColumnCategory[]
  selectedColumns: string[]
  onClose: () => void
  onToggle: (columnId: string) => void
}

export const ColumnPickerCategories = ({
  columnCategories,
  onClose,
  onToggle,
  selectedColumns,
}: ColumnPickerCategoriesProps) => {
  const { currentCategory, setCurrentCategory } = useCategorySelection(columnCategories)
  const { query, setQuery } = useAvailableColumnsQuery(currentCategory)

  return (
    <S.CategoriesRoot>
      <S.CategoriesContent>
        <S.CategoriesHeader>
          <IconButton
            size="small"
            onClick={getExitOnClick({
              columnCategories,
              currentCategory,
              onClose,
              setCurrentCategory,
            })}
            data-test-id="close-search"
          >
            {getExitIcon(columnCategories, currentCategory)}
          </IconButton>
          <Typography variant="body2">
            {currentCategory?.name ?? <FormattedMessage {...messages.categories} />}
          </Typography>
        </S.CategoriesHeader>
        {currentCategory ? (
          <ColumnPickerAvailableNodes
            currentCategory={currentCategory}
            selectedColumns={selectedColumns}
            query={query}
            setQuery={setQuery}
            onToggle={onToggle}
          />
        ) : (
          <ColumnPickerCategoryList
            columnCategories={columnCategories}
            setCurrentCategory={setCurrentCategory}
          />
        )}
      </S.CategoriesContent>
      {currentCategory && (
        <ColumnPickerPagination
          query={query}
          hasNextPage={currentCategory.hasNextPage}
          hasPreviousPage={currentCategory.hasPreviousPage}
          onNextPage={currentCategory.onNextPage}
          onPreviousPage={currentCategory.onPreviousPage}
        />
      )}
    </S.CategoriesRoot>
  )
}
